
import { ISDKInfo } from 'kentico-cloud-core';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '6.2.0',
    name: 'kentico-cloud-delivery'
};
